import PropTypes from 'prop-types';
import React from 'react';
import styles from './DomoAppPreview.css?module';
import {fetchDomoAppPreview} from 'state/card/cardService';
import Busy from 'components/activity/Busy';
import {getBaseURL} from './DomoAppService';
import {getEnvironment} from 'state/environment/environmentSelectors';
import {connect} from 'react-redux';
import {cancelRequest} from 'utilities/Request';

const screenShotWidth = 1024;

class DomoAppPreview extends React.Component {
  state = {
    previewUrl: null,
    previewUrlRetrievalFailed: false,
  };

  getDomoAppPreview = () => {
    this.setState({previewUrl: null, previewUrlRetrievalFailed: false});
    cancelRequest(this.request);

    const containerRatio = this.props.height / this.props.width;
    const scale = this.props.width / screenShotWidth;
    const screenShotHeight = screenShotWidth * containerRatio;

    this.request = fetchDomoAppPreview(this.props.cardId, {
      width: screenShotWidth,
      height: screenShotHeight,
      scale,
    });

    this.request.then(
      (blob) => {
        this.setState({previewUrl: URL.createObjectURL(blob)});
      },
      () => {
        this.setState({
          previewUrl: `${getBaseURL(
            this.props.cardId,
            this.props.pageId,
            this.props.domoappId,
            this.props.environment.domoappsDomain
          )}/thumbnail.png`,
          previewUrlRetrievalFailed: true,
        });
      }
    );
  };

  componentDidMount() {
    this.getDomoAppPreview();
  }

  componentDidUpdate(prevProps) {
    // only update chart if the data has changed
    if (
      prevProps.width !== this.props.width ||
      prevProps.height !== this.props.height
    ) {
      this.getDomoAppPreview();
    }
  }

  componentWillUnmount() {
    cancelRequest(this.request);
  }

  render() {
    const {width, height} = this.props;

    // If the previewUrlRetrievalFailed, we will display the icon
    // provided with the domo app which is square at 300x300.
    const style = this.state.previewUrlRetrievalFailed
      ? {height, width: height}
      : {width, height};

    return (
      <Busy isLoading={!this.state.previewUrl}>
        <img
          src={this.state.previewUrl}
          style={style}
          className={styles.container}
        />
      </Busy>
    );
  }
}

DomoAppPreview.propTypes = {
  cardId: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  domoappId: PropTypes.string.isRequired,
  pageId: PropTypes.string.isRequired,
};

export default connect((state) => ({
  environment: getEnvironment(state),
}))(DomoAppPreview);
